const LeadSource = () => {
    return (
        <div>
            <h1>Источник</h1>
        </div>
    );
};

export default LeadSource;
